import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { parseAmount, toInputAmount } from "../lib/format";

const DOC_TYPES = ["Rechnung", "Gutschrift", "Kreditkartenabrechnung", "Vorschreibung", "Bescheid", "Ausgangsrechnung", "Vertrag", "Kassenbon/Quittung", "Zahlungsbestätigung", "Sonstiges"];
const TEXT = [["vendor", "Aussteller / Händler"], ["invoice_number", "Rechnungsnummer"], ["description", "Beschreibung"], ["currency", "Währung"]];
const DATES = [["invoice_date", "Rechnungsdatum"], ["payment_date", "Zahlungsdatum"], ["service_period_from", "Leistung von"], ["service_period_to", "Leistung bis"]];
const NUMS = [["gross_total", "Bruttobetrag"], ["net_amount", "Netto"], ["vat_amount", "USt-Betrag"]];

export const ReceiptEditDialog = ({ rc, open, onOpenChange, onSave }) => {
  const [f, set] = useState({});
  const init = () => {
    const e = rc.extracted || {};
    set({ ...Object.fromEntries([...TEXT, ...DATES].map(([k]) => [k, e[k] || ""])), ...Object.fromEntries(NUMS.map(([k]) => [k, toInputAmount(e[k])])),
      vat_rate: e.vat_rate ?? "", document_type: e.document_type || "Rechnung", direction: e.direction || "ausgabe" });
  };
  const submit = () => {
    const body = { document_type: f.document_type, direction: f.direction, vat_rate: f.vat_rate === "" ? null : parseFloat(String(f.vat_rate).replace(",", ".")) };
    [...TEXT, ...DATES].forEach(([k]) => { body[k] = f[k] || null; });
    NUMS.forEach(([k]) => { body[k] = parseAmount(f[k]); });
    onSave(body);
  };
  const field = ([k, label], type = "text") => (
    <div key={k} className="grid gap-1">
      <Label htmlFor={`rc-${k}`} className="text-xs font-semibold text-slate-600">{label}</Label>
      <Input id={`rc-${k}`} type={type} data-testid={`receipt-field-${k}`} value={f[k] ?? ""} onChange={(e) => set({ ...f, [k]: e.target.value })} className="h-10" />
    </div>
  );
  return (
    <Dialog open={open} onOpenChange={(o) => { if (o) init(); onOpenChange(o); }}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-xl" data-testid="receipt-edit-dialog">
        <DialogHeader><DialogTitle>Belegdaten bearbeiten</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {TEXT.map((x) => field(x))}
          {DATES.map((x) => field(x, "date"))}
          {NUMS.map((x) => field(x))}
          {field(["vat_rate", "USt-Satz %"])}
          <div className="grid gap-1">
            <Label className="text-xs font-semibold text-slate-600">Belegart</Label>
            <select data-testid="receipt-field-document_type" value={f.document_type} onChange={(e) => set({ ...f, document_type: e.target.value })} className="h-10 rounded-md border border-input bg-white px-2 text-sm">
              {DOC_TYPES.map((d) => <option key={d}>{d}</option>)}
            </select>
          </div>
          <div className="grid gap-1">
            <Label className="text-xs font-semibold text-slate-600">Richtung</Label>
            <select data-testid="receipt-field-direction" value={f.direction} onChange={(e) => set({ ...f, direction: e.target.value })} className="h-10 rounded-md border border-input bg-white px-2 text-sm">
              <option value="ausgabe">Ausgabe</option><option value="einnahme">Einnahme</option>
            </select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Abbrechen</Button>
          <Button data-testid="receipt-edit-save-btn" onClick={submit}>Speichern & neu zuordnen</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
